/*
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-11-13 13:26:35
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-11-17 11:07:04
 */
import Vue from 'vue'
import Router from 'vue-router'

import routes from './routes'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/auth' : '/',
  routes,
})
